import { createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from 'store';
import moment from 'moment';
import { FORMAT_DATETIME } from 'utils/constants';
import { getUnitIntegrationTaskListFetcher } from './unit-integration.services';

export const getUnitIntegrationTaskListThunk = createAsyncThunk(
    'unitIntegration/getList',
    async (params: IUnitIntegrationTaskSearch | undefined, thunkAPI) => {
        const state = thunkAPI.getState() as RootState;
        const { paginateMetaData, sort } = state.unitIntegration;

        const isValidValue = (value: unknown) =>
            value !== null && value !== undefined && value !== '';
        const isDateKey = (key: string) => ['created_date_from', 'created_date_to'].includes(key);
        const formatDateValue = (value: unknown) =>
            moment.utc(value as string).format(FORMAT_DATETIME.YYYYMMDD2);

        const cleanedFilter = Object.entries(params ?? {}).reduce<Record<string, unknown>>(
            (acc, [key, value]) => {
                if (!isValidValue(value)) return acc;
                acc[key] = isDateKey(key) ? formatDateValue(value) : value;
                return acc;
            },
            {},
        );

        if (params?.status === undefined || params?.status === '') {
            cleanedFilter.status = ['0', '1'];
        } else {
            cleanedFilter.status = [params.status];
        }

        const sortStr = sort?.fieldName
            ? `${sort.fieldName}:${sort.ascending ? 'asc' : 'desc'}`
            : undefined;

        const request: UnitIntegrationTaskListRequest = {
            page: paginateMetaData.page,
            per_page: paginateMetaData.per_page,
            filter: JSON.stringify(cleanedFilter),
            ...(sortStr ? { sort: sortStr } : {}),
        };

        const res = await getUnitIntegrationTaskListFetcher(request);
        if (!res.success) return thunkAPI.rejectWithValue(res.error);
        return res.data;
    },
);
